<template>
    <!-- Popular Section -->
	<section class="section popular-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center mb-4">
						<h2 class="mb-1">Our Popular <span class="text-linear-primary">Services</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<ul class="nav nav-tabs nav-tabs-solid justify-content-center mb-4">
				<li class="nav-item mb-3">
					<a class="nav-link" :class="{ active: activeTab === 'computer-service' }"
						@click="activeTab = 'computer-service'" href="javascript:void(0);"
						data-bs-toggle="tab">Computer Service</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'removals' }"
						@click="activeTab = 'removals'" data-bs-toggle="tab">Removals</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'man' }"
					@click="activeTab = 'man'" data-bs-toggle="tab">Man & Van</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'furniture' }"
					@click="activeTab = 'furniture'" data-bs-toggle="tab">Furniture Assembly</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'electrical' }"
					@click="activeTab = 'electrical'" data-bs-toggle="tab">Electrical</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'construction' }"
					@click="activeTab = 'construction'" data-bs-toggle="tab">Construction</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'plumbing' }"
					@click="activeTab = 'plumbing'" data-bs-toggle="tab">Plumbing</a>
				</li>
				<li class="nav-item mb-3">
					<a class="nav-link" href="javascript:void(0);" :class="{ active: activeTab === 'more-service' }"
					@click="activeTab = 'more-service'" data-bs-toggle="tab">More Services</a>
				</li>
			</ul>
			<div class="tab-content">
				<div class="tab-pane" :class="{ active: activeTab === 'computer-service' }"
          			v-if="activeTab === 'computer-service'" id="computer-service">
					<computer-service></computer-service>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'removals' }"
				v-if="activeTab === 'removals'" id="removals">
					<removals-carousel></removals-carousel>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'man' }"
				v-if="activeTab === 'man'" id="man">
					<man-van></man-van>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'furniture' }"
				v-if="activeTab === 'furniture'" id="furniture">
					<furniture-assembly></furniture-assembly>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'electrical' }"
				v-if="activeTab === 'electrical'" id="electrical">
					<electrical-carousel></electrical-carousel>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'construction' }"
				v-if="activeTab === 'construction'" id="construction">
					<construction-carousel></construction-carousel>
				</div>
				<div class="tab-pane" :class="{ active: activeTab === 'plumbing' }"
				v-if="activeTab === 'plumbing'" id="plumbing">
					<plumbing-carousel></plumbing-carousel>
				</div> 
				<div class="tab-pane" :class="{ active: activeTab === 'more-service' }"
				v-if="activeTab === 'more-service'" id="more-service">
					<more-service></more-service>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="text-center wow fadeInUp mt-5" data-wow-delay="0.2s">
						<router-link to="/service/search" class="btn btn-dark">View All<i
								class="ti ti-arrow-right ms-2"></i></router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /Popular Section -->
</template>

<script>
export default {
    data() {
        return {
            activeTab: "computer-service",
        }
    },
	watch: {
    activeTab() {
      this.$nextTick(() => {
        const carousel = this.$refs.carousel;
        if (carousel) {
          carousel.restart();
        }
      });
    },
  },
}
</script>